"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[406],{

/***/ 4406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ price_Price; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/begonya/functions/index.js
var functions = __webpack_require__(44);
// EXTERNAL MODULE: ./core/contexts/app/index.tsx + 1 modules
var contexts_app = __webpack_require__(9617);
// EXTERNAL MODULE: ./components/base/gridview/index.tsx + 4 modules
var gridview = __webpack_require__(7923);
// EXTERNAL MODULE: ./components/base/image/Image.tsx
var Image = __webpack_require__(4297);
;// CONCATENATED MODULE: ./components/widgets/price/Price.tsx






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Price = function(param1) {
    var title = param1.title, data = param1.data, description = param1.description;
    var formattedPrice;
    var app = (0,contexts_app/* useApp */.qD)();
    var itemCount = (data === null || data === void 0 ? void 0 : data.length) || 0;
    var xlColumnSize = itemCount <= 1 ? 12 : itemCount === 2 ? 6 : 4;
    var PriceFormatter = function(param) {
        var amount = param.amount, currency = param.currency;
        if (currency === 'try') {
            formattedPrice = "".concat(amount, " ₺");
        } else if (currency === 'usd') {
            formattedPrice = "".concat(amount, " $");
        } else if (currency === 'euro') {
            formattedPrice = "".concat(amount, " €");
        } else {
            formattedPrice = "".concat(amount, " ").concat(currency);
        }
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: formattedPrice
        }));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,functions.classnames)('price section'),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(gridview/* Container */.W2, {
            size: "extended",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
                    xs: {
                        align: 'center'
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                        xs: {
                            size: 12
                        },
                        sm: {
                            size: 12
                        },
                        md: {
                            size: 12
                        },
                        lg: {
                            size: 12
                        },
                        xl: {
                            size: 12
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "section-title text-center",
                            children: title
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(gridview/* Row */.X2, {
                    children: data === null || data === void 0 ? void 0 : data.map(function(item, index) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(gridview/* Column */.sg, {
                            xs: {
                                size: 12
                            },
                            sm: {
                                size: 12
                            },
                            md: {
                                size: 12
                            },
                            lg: {
                                size: 6
                            },
                            xl: {
                                size: xlColumnSize
                            },
                            className: "price-list",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "price-list-item",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "desc",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, _objectSpread({}, item.icon, {
                                                    alt: item.title
                                                }))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "title",
                                                children: [
                                                    item.title,
                                                    ' ',
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        dangerouslySetInnerHTML: {
                                                            __html: app.settings.translations['charge']
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "price",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "price-d",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: app.settings.translations['price']
                                                    }
                                                }),
                                                ' ',
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceFormatter, {
                                                    amount: item.price.amount,
                                                    currency: item.price.currency
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "price-announce",
                    dangerouslySetInnerHTML: {
                        __html: description || ''
                    }
                })
            ]
        })
    }));
};
/* harmony default export */ var price_Price = (Price);

;// CONCATENATED MODULE: ./components/widgets/price/index.ts



/***/ })

}]);